import { SelectProps } from 'antd';
import { useMemo, VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { OutputTechnology } from '@enmon/commons/lib/tools';
import { Select } from './Select';
import { SelectMessages as messages } from './messages';
import { filterOption } from './utils';

type AddonOutputSelectProps = SelectProps;

export const AddonOutputSelect: VFC<AddonOutputSelectProps> = props => {
  const options = useMemo(() => {
    return Object.values(OutputTechnology).map(addonOutput => ({
      label: addonOutput,
      value: addonOutput,
    }));
  }, []);

  return (
    <Select
      allowClear
      showSearch
      className="w-100"
      filterOption={filterOption}
      options={options}
      placeholder={<FormattedMessage {...messages.meterAddonOutputPlaceholder} />}
      {...props}
    />
  );
};
